import Pages from "./Pages";
import Screens from "./Screens";
import Events from "./Events";

export default {
    Pages, Screens, Events
};